import MonthRangePicker from "@components/inputs/date/MonthRangePicker";
import { IDayInterval } from "@components/inputs/date/utils";
import { getSharedInputProps, IInputOnChangeEvent } from "@components/inputs/input";
import { getDateFromMonth, getMonthFromDate } from "@components/smart/Smart.utils";
import { isNotDefined } from "@utils/general";
import React, { Component } from "react";

import { Model } from "../../../model/Model";
import { IValidationError } from "../../../model/Validator.types";
import DateType from "../../../types/Date";

interface IProps {
    storage: Model;
    onChange: (data: IInputOnChangeEvent) => void;
    width?: string;
    error?: IValidationError;
    fromPath: string;
    toPath: string;
}

class SmartMonthRangePicker extends Component<IProps> {
    handleChange = (e: IInputOnChangeEvent<IDayInterval>): void => {
        const storage = this.props.storage;
        const value = e.value;

        if (DateType.isValid(value?.from) && DateType.isValid(value?.to)) {
            const { from, to } = value;
            storage.setValueByPath(this.props.fromPath, getMonthFromDate(from));
            storage.setValueByPath(this.props.toPath, getMonthFromDate(to));
        }

        this.props.onChange({
            value: {
                from: value?.from,
                to: value?.to
            }
        });
    }

    getValue = (): IDayInterval => {
        const storage = this.props.storage;
        const from = storage.getValueByPath(this.props.fromPath) as number;
        const to = storage.getValueByPath(this.props.toPath) as number;
        if (isNotDefined(from) || isNotDefined(to)) {
            return null;
        }
        return {
            from: getDateFromMonth(from),
            to: getDateFromMonth(to)
        };
    };

    render() {
        return <MonthRangePicker value={this.getValue()}
                                 onChange={this.handleChange}
                                 {...getSharedInputProps(this.props)}/>;
    }
}

export default SmartMonthRangePicker;